import React from 'react';
import Link from 'react-router-dom/Link';
import Button from './Button';

function ButtonLink(props) {
  const RouterLink = React.forwardRef((linkProps, ref) => (
    <Link to={linkProps.href} {...linkProps} innerRef={ref} />
  ));

  return <Button {...props} component={RouterLink} />;
}

export default ButtonLink;
